import { render, staticRenderFns } from "./outside-criteria-products.vue?vue&type=template&id=16c2c830&scoped=true&"
import script from "./outside-criteria-products.vue?vue&type=script&lang=js&"
export * from "./outside-criteria-products.vue?vue&type=script&lang=js&"
import style0 from "./outside-criteria-products.vue?vue&type=style&index=0&id=16c2c830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2c830",
  null
  
)

export default component.exports